export function handleValueChange<T>(
  fn: (field: keyof T, value: string | number | boolean) => void,
  field: keyof T,
  value?: string | number | boolean,
) {
  if (value) {
    fn(field, value)
  }
}
